import { useState, useEffect } from 'react';
import type { IcpMasterData, IcpConfig } from '../types/icp';
import { getIcpMasterData, getIcpConfig } from '../services/icpService';

export function useIcpMasterData() {
  const [masterData, setMasterData] = useState<IcpMasterData | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    getIcpMasterData()
      .then(data => {
        if (!cancelled) {
          setMasterData(data);
          setLoading(false);
        }
      })
      .catch(err => {
        if (!cancelled) {
          setError(err.message);
          setLoading(false);
        }
      });
    return () => { cancelled = true; };
  }, []);

  return { masterData, loading, error };
}

export function useIcpConfig(clientId: string | undefined) {
  const [config, setConfig] = useState<IcpConfig | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!clientId) {
      setLoading(false);
      return;
    }

    let cancelled = false;
    getIcpConfig(clientId)
      .then(data => {
        if (!cancelled) {
          setConfig(data);
          setLoading(false);
        }
      })
      .catch(err => {
        if (!cancelled) {
          setError(err.message);
          setLoading(false);
        }
      });
    return () => { cancelled = true; };
  }, [clientId]);

  return { config, setConfig, loading, error };
}
